
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function AnalFissure(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Anal fissure"}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>An anal fissure is a small tear in the thin, moist tissue (mucosa) that
                                    lines the anus. An anal fissure may occur when you pass hard or
                                    large stools during a bowel movement. Anal fissures typically cause
                                    pain and bleeding with bowel movements. You also may experience
                                    spasms in the ring of muscle at the end of your anus (anal
                                    sphincter).</p>

                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Anal-fissure/1.png")} alt="Anal-fissure" />
                                    </div>
                                </div>
                                <br></br>
                                <p><b>Symptom</b></p>
                                <p>Pain, sometimes severe, during bowel movements</p>
                                <p>Pain after bowel movements that can last up to several hours</p>
                                <p>Bright red blood on the stool or toilet paper after a bowel movement</p>
                                <p>A visible crack in the skin around the anus</p>
                                <a className="links" href="https://en.wikipedia.org/wiki/Anal_fissure">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default AnalFissure;